import Layout from '@/layout/default'

const prizeRouter = {
  path: '/prize',
  name: 'prize',
  component: Layout,
  children: [
    {
      path: 'assist',
      name: 'assist',
      meta: {
        title: "好友助力",
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/prize/assist.vue')
    },
    {
      path: 'prize_detail',
      name: 'prize_detail',
      meta: {
        title: "抽奖详情",
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/prize/prize_detail.vue')
    },
    {
      path: 'rednote',
      name: 'rednote',
      meta: {
        title: "小红书种草活动",
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/prize/rednote.vue')
    },
    {
      path: 'rednote_prize_rule',
      name: 'rednote_prize_rule',
      meta: {
        title: "抽奖规则说明",
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/prize/rednote_prize_rule.vue')
    },
    {
      path: 'submit_List',
      name: 'submit_list',
      meta: {
        title: "提报活动列表",
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/prize/submitList.vue')
    },
    {
      path: 'submit_rule',
      name: 'submit_rule',
      meta: {
        title: "提报活动规则",
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/prize/submitRule.vue')
    },
    {
      path: 'submit_detail',
      name: 'submit_detail',
      meta: {
        title: "活动详情",
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/prize/submitDetail.vue')
    }
  ]
}

export default prizeRouter
